const headerLinkNode = document.querySelector('a.header-with-location____logo-link');

/**
 * @param {bool} skip
 * @param priod из запроса basket
 * @description Устанавливает query параметр period в ссылку в header'e
 */
export const paramToHeaderLinkSetter = (skip) => ({ period }) => {
    if (skip) {
        headerLinkNode.setAttribute('href', '/');
    } else {
        headerLinkNode.setAttribute('href', `/?period=${period}`);
    }
};
